// @ts-nocheck
import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(quantityOrderedStyles, {
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                flex-direction: column;
                margin-top: 0;
                margin-right: ${pxToRem(15)};
                width: auto;
            `,
        },
        labelProps: {
            css: css`
                font-size: ${x => x.theme.design.typography.size.tiny};
                font-weight: ${x => x.theme.design.typography.weight.medium};
                line-height: ${x => x.theme.design.typography.lineHeight.larger};
                margin-right: ${pxToRem(15)};

                ${breakpoint("sm", "down")} {
                    width: auto;
                }
            `,
        },
    },
});
